import React from 'react';
import {ReactSVG} from "react-svg";
import {getPublicImagePath} from "@nutastic/nutastic-react-app";

const componentClass = 'footer';

const Footer = () => {
    const copyrightYear = new Date().getFullYear();

    return <footer className={componentClass}>
        <div className="container">
            <ReactSVG src={getPublicImagePath('logo--wide.svg')} className="footer__logo" />
            <div className="footer__nav">
                <a href="#!">Contact</a>
                <a href="#!">About</a>
                <a href="#!">Licensing</a>
                <a href="#!">Visit ThaNetWORK</a>
            </div>
            <div className={`footer__copyright`}>
                <span>QuistarGo.com • QuistarGo LLC • Time2Go2Work Ent. &copy; { copyrightYear } • All Rights Reserved • <i>Official Member of ThaNetWORK</i></span>
            </div>
        </div>
    </footer>;
};

export default Footer;
